
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.75 2.25H1.25C.56 2.25 0 2.81 0 3.5v9c0 .69.56 1.25 1.25 1.25h13.5c.69 0 1.25-.56 1.25-1.25v-9c0-.69-.56-1.25-1.25-1.25zM.5 12.5V4.25h3.25v9h-2.5a.75.75 0 01-.75-.75zm14.25.75H4.25v-9H14a.25.25 0 100-.5H.5V3.5a.75.75 0 01.75-.75h13.5a.75.75 0 01.75.75v.25H15a.25.25 0 100 .5h.5v8.25a.75.75 0 01-.75.75z","fill":"#6C6C6C"}}),_c('path',{attrs:{"d":"M1.25 3a.252.252 0 00-.177.427.252.252 0 00.354 0 .252.252 0 000-.354A.252.252 0 001.25 3zM2 3a.252.252 0 00-.177.427.252.252 0 00.354 0 .252.252 0 000-.354A.252.252 0 002 3zM2.75 3a.252.252 0 00-.177.427.252.252 0 00.354 0 .252.252 0 000-.354A.252.252 0 002.75 3zM1.25 5.25H3a.25.25 0 000-.5H1.25a.25.25 0 000 .5zM3 5.75H1.25a.25.25 0 000 .5H3a.25.25 0 000-.5zM6.75 7.5c.334 0 .648.13.884.366a.25.25 0 00.353-.353A1.752 1.752 0 005 8.75c0 .468.182.907.513 1.238.34.34.789.511 1.237.511.448 0 .896-.17 1.237-.511a.25.25 0 10-.353-.354c-.236.236-.55.366-.884.366-.334 0-.648-.13-.884-.366A1.242 1.242 0 015.5 8.75c0-.334.13-.648.366-.884s.55-.366.884-.366zM10.25 9.396A1.251 1.251 0 009.75 7h-1a.25.25 0 00-.249.275v2.975a.25.25 0 10.5 0V7.5h.75a.75.75 0 010 1.5.25.25 0 00-.177.427l1 1a.25.25 0 00.354 0 .25.25 0 000-.354l-.677-.677zM14.315 7.008a.25.25 0 00-.282.12l-1.031 1.857L11.97 7.13a.25.25 0 00-.468.121v3a.25.25 0 10.5 0V8.215l.781 1.406a.25.25 0 00.438 0l.781-1.406v2.035a.25.25 0 10.5 0v-3a.25.25 0 00-.187-.242z","fill":"#6C6C6C"}})])
          )
        }
      }
    